const Advert = require('./advert');

class Advert_One extends Advert {
  constructor() {
    super();
    this.data;
    this.ex;
    this.admData;
    this.GD_params;
    this.DOM;
  }

  SetDOM() {
    this.DOM = $(`<div><div class="m-ad-4-col" ${this.IsInPc() ? '' : 'type="xlyx-count-item"'} data-game-id="${this.admData.gameId}" data-game-name="${this.gameBaseInfo.gameName}" >
  <div  class="card item-card-3">
    <div class="card-3-banner download ${this.ex.qdown === '0' ? 'stat-recsys-down' : 'stat-recsys-app-down'}">
        <div class="banner-scroll-to-left"></div>
        <div class="banner-scroll-to-right"></div>
        <ul class="banner-scroll" style="right:0px">
        ${this.ex.image1Url ? `<li>
            <img src="${this.ex.image1Url}" />
          </li>` : ''}
        ${this.ex.image2Url ? `<li>
            <img src="${this.ex.image2Url}" />
          </li>` : ''}
        ${this.ex.image3Url ? `<li>
            <img src="${this.ex.image3Url}" />
          </li>` : ''}
        </ul>
    </div>
    <div class="gd-game-item">
      <div class="game-icon stat-recsys-click href-to-gamezone" >
            <img src="${this.gameBaseInfo.logo}" />
      </div>
      <div class="game-info stat-recsys-click href-to-gamezone">
        <p class="info-title">${this.gameBaseInfo.gameName}</p>
        <div class="info-detail">
          <ul>
            <li>${this.gameBaseInfo.category}</li>
            ${this.gameBaseInfo.fileSize ? `<li>${this.gameBaseInfo.fileSize}</li>` : ''}
            ${this.gameBaseInfo.expertScore ? `<li>九游评分：<span class="detail-score">${this.gameBaseInfo.expertScore}</span></li>` : ''}
          </ul>
        </div>
        ${this.gameBaseInfo.instruction ? `<div class="info-abstract">${this.gameBaseInfo.instruction}</div>` : ''}
      </div>
      <div  class="game-btn download ${this.IsInPc() ? '' : 'game-recommend-download'} ${this.ex.qdown === '0' ? 'stat-recsys-down' : 'stat-recsys-app-down'}">${this.gameBaseInfo.packageproperty ? '下载' : '预约'}</div>
    </div>
  </div>
</div><!--*{游戏推荐 下了又下模块}*-->${this.renderXlyx()}</div>`);

    this.InitEvent();
  }

  InitEvent() {
    // this.InitScrollInPC();
    this.InitButtonEvent();
  }

  InitScrollInPC() {
    const $root = this.DOM;
    let position = 0;
    const trans = 100;
    if (this.IsInPc()) {
      $root.find('.banner-scroll-to-left').toggle(true).on('click', e => {
        const width = ($root.find('.banner-scroll').find('li').length - 5) * 120;
        if (position > width) return;
        position += trans;
        $root.find('.banner-scroll').animate({ right: position + 'px' }, 'fast');
        return false;
      }, true);
      $root.find('.banner-scroll-to-right').toggle(true).on('click', e => {
        const width = ($root.find('.banner-scroll').find('li').length - 5) * 120;
        if (position === '0') return;
        position -= trans;
        $root.find('.banner-scroll').animate({ right: position + 'px' }, 'fast');
        return false;
      }, true);
    }
  }

  InitButtonEvent() {
    this.DOM.find('.download').on('click', e => {
      const ch = this.ex.qdownCh || 'OK_2434';
      this.pullUp(this.admData.gameId, `ag_ugt-seo-nrzrgg-zx_${this.GD_params.odId}-gd_${this.admData.adpId}-wl_${this.admData.admId}-gid_${this.admData.gameId}`, ch, this.gameBaseInfo.packageproperty);
      // if (this.ex.qdown === '0' && this.gameBaseInfo.downUrl) {
      //   window.location = this.gameBaseInfo.downUrl + `?ch=${this.ex.downCh}`;
      // } else {
      //   this.pullUp(this.admData.gameId, `ag_ugt-seo-nrzrgg-zx_${this.GD_params.odId}-gd_${this.admData.adpId}-wl_${this.admData.admId}-gid_${this.admData.gameId}`, this.ex.qdownCh, this.gameBaseInfo.packageproperty);
      // }
    });
  }
}

module.exports = Advert_One;


// WEBPACK FOOTER //
// ./lib/js/module/m_advert/module/advert_four_col.js